import { Checkbox } from 'antd';
import styled from 'styled-components';
import { BREAKPOINTS } from 'constants/Global/Breakpoints.const';

export const Container = styled.div`
  width: 280px;
  min-width: 280px;
  padding: 16px 32px;
  position: relative;
  background-color: #fff;

  @media (min-width: ${BREAKPOINTS.tabletMini}) {
    margin: 24px 16px 8px 0;
    margin-top: -88px;
  }

  .ant-row.ant-form-item {
    margin-bottom: 4px !important;
  }

  .collapse-drawer-filter {
    margin: 0px;

    .ant-collapse-item {
      .ant-collapse-header {
        color: #000 !important;
        font-weight: 700 !important;
        font-size: 10px;

        svg {
          color: #f78e1e !important;
          transform: rotate(90deg) !important;
        }
      }

      &-active {
        .ant-collapse-header {
          svg {
            transform: rotate(-90deg) !important;
          }
        }
      }
    }

    .ant-input-search-button {
      color: #000 !important;
    }

    .ant-checkbox-wrapper {
      color: #000 !important;
      font-size: 12px;
    }
  }
`;

export const SpanSelectAllAndDeselectAll = styled.span`
  cursor: pointer;
  margin-top: 8px;
  color: #000;
  background-color: #f5f5f5;
  border: 1px solid #d9d9d9;
  padding: 8px;
  border-radius: 2px;
  gap: 4px;
`;

export const SeparateSpans = styled.span`
  position: relative;
  color: #f78e1e;
  margin-right: 8px;
`;

export const GroupSelectAndDeselect = styled.div`
  display: flex;
  align-items: center;
`;

export const CheckboxComponent = styled(Checkbox)`
  display: flex;
  flex-direction: row;

  label {
    font-size: 12px !important;
  }
  span {
    font-size: 12px !important;
  }
`;

export const CheckboxGroup = styled(Checkbox.Group)`
  display: flex;
  flex-direction: column;

  label {
    font-size: 12px !important;
  }
`;

export const ContentClean = styled.span`
  margin-top: 20px;
  margin-bottom: 20px;
  display: flex;
  justify-content: flex-start;
`;
